import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import MemberService from '../../../../services/MemberService';
import { DragDropContext } from 'react-beautiful-dnd';
import GoogleMap from './GoogleMap';
import DisplayJob from './DisplayJob';
import MemberJobList from './MemberJobList';
import moment from 'moment';
import DatePicker from 'react-datepicker/es';
import UnassignedJobsList from './UnassignedJobsList';
import FormMultiSelect from '../../../_shared/forms/FormMultiSelect';
import DateJobsList from './DateJobsList';
import AdminNotesModal from './Modals/AdminNotesModal';
import FormCheckbox from '../../../_shared/forms/FormCheckbox';
import UpdateExecutionDateModal from './Modals/UpdateExecutionDateModal';
import ReassignToSubContractorModal from './Modals/ReassignToSubContractorModal';
import TipOffModal from './Modals/TipOffsModal';
import JobService from '../../../../services/JobService';

class MembersJobsList extends Component {
    constructor(props) {
        super(props);

        let iconColors = [
            '#0b5fc6',
            '#0a8665',
            '#6a3c67',
            '#900404',
            '#989898',
            '#99d6fa',
            '#55da6d',
            '#f28218',
            '#b20fa4',
            '#f0d81f',
            '#754000',
            '#fe53f0',
        ];

        const mapToSelectOption = (member) => ({
            value: member.id,
            label: member.name,
        });

        this.state = {
            unassignedJobs: this.props.unassignedJobs,
            daysOrder: this.props.daysOrder,
            members: this.props.members,
            onHoldJobs: this.props.onHoldJobs,
            loading: false,
            showJob: { memberId: 0, job: 0 },
            jobs: this.props.jobs,
            selected_date: new Date(this.props.selectedDate),
            recreatePins: false,
            iconColors: iconColors,
            tip_offs: this.props.tipOffs || [],
            modalShow: false,
            modalJob: null,
            show_tip_offs: this.props.showTipoffs || false,
            show_waste_containers: this.props.showWasteContainers || false,
            activeTab: 'date',
            selectedJobs: [],
            showUpdateExecutionDateModal: false,
            tipOffModalShow: false,
            tipOffOperative: null,
            serviceProviders: this.props.serviceProviders,
            selected_members: (this.props.selectedMembers?.length
                ? this.props.selectedMembers
                : this.props.assignedOperatives || []
            ).map(mapToSelectOption),
        };

        this.showUpdateExecutionDateModal = this.showUpdateExecutionDateModal.bind(this);
        this.showReassignToSubContractorModal = this.showReassignToSubContractorModal.bind(this);
        this.memberService = new MemberService();
        this.jobService = new JobService();
    }

    setTipOffModalShow = (show, member) => {
        this.setState({
            tipOffModalShow: show,
            tipOffOperative: member,
        });
    };

    showUpdateExecutionDateModal(e, show) {
        e.stopPropagation();

        this.setState({
            showUpdateExecutionDateModal: show,
        });
    }

    showReassignToSubContractorModal(e, show) {
        e.stopPropagation();

        this.setState({
            showReassignToSubContractorModal: show,
        });
    }

    setActiveTab = (tab) => {
        this.setState({ activeTab: tab });
    };

    updateSpecialRequests = (jobId, specialRequests) => {
        this.jobService
            .updateSpecialRequests(jobId, specialRequests)
            .then((res) => {
                toastr.success('Special requests saved');

                // Safe updater: ensures jobs is always an array
                const updateJobInState = (jobs) =>
                    Array.isArray(jobs)
                        ? jobs.map((job) => (job.id === jobId ? { ...job, special_requests: specialRequests } : job))
                        : [];

                this.setState((prevState) => ({
                    unassignedJobs: updateJobInState(prevState.unassignedJobs),
                    onHoldJobs: updateJobInState(prevState.onHoldJobs),
                    jobs: updateJobInState(prevState.jobs),
                    members: prevState.members.map((member) => {
                        const selectedDate = moment(prevState.selected_date).format('YYYY-MM-DD');

                        // Only update if jobs exist for this date
                        if (Array.isArray(member.mapped_jobs?.[selectedDate])) {
                            member.mapped_jobs[selectedDate] = updateJobInState(member.mapped_jobs[selectedDate]);
                        }
                        return member;
                    }),
                }));
            })
            .catch((err) => {
                console.error('updateSpecialRequests failed', { jobId, err });
                toastr.error('Failed to save special requests');
            });
    };

    unassignedToMember = (destination, source, draggableId) => {
        let onHoldJobs = this.state.onHoldJobs.slice();
        let members = this.state.members.slice();
        let selected_date = moment(this.state.selected_date).format('YYYY-MM-DD');

        //Get member that receives the job
        let destinationId = destination.droppableId;
        let destinationMemberIndex = members.findIndex((member) => member.id === Number(destinationId));
        let destinationMember = { ...members[destinationMemberIndex] };

        //Get dragged job from unassigned jobs
        let jobId = Number(draggableId.substr(draggableId.indexOf('-') + 1));
        let jobIndex = onHoldJobs.findIndex((job) => job.id === jobId);
        let job = { ...onHoldJobs[jobIndex], execution_date: selected_date };
        job.on_hold = false;

        onHoldJobs.splice(source.index, 1);

        typeof destinationMember['mapped_jobs'][selected_date] === 'undefined'
            ? (destinationMember['mapped_jobs'][selected_date] = [])
            : '';
        destinationMember['mapped_jobs'][selected_date].splice(destination.index, 0, job);
        members[destinationMemberIndex] = destinationMember;

        this.assignJobToMember(
            members[destinationMemberIndex]['mapped_jobs'][selected_date],
            members[destinationMemberIndex].id
        );

        return {
            ...this.state,
            members: members,
            onHoldJobs: onHoldJobs,
            recreatePins: true,
        };
    };

    dateToMember = (destination, source, draggableId) => {
        let unassignedJobs = this.state.unassignedJobs.slice();
        let members = this.state.members.slice();
        let selected_date = moment(this.state.selected_date).format('YYYY-MM-DD');

        //Get member that receives the job
        let destinationId = destination.droppableId;
        let destinationMemberIndex = members.findIndex((member) => member.id === Number(destinationId));
        let destinationMember = { ...members[destinationMemberIndex] };

        //Get dragged job from unassigned jobs
        let jobId = Number(draggableId.substr(draggableId.indexOf('-') + 1));
        let jobIndex = unassignedJobs.findIndex((job) => job.id === jobId);
        let job = {
            ...unassignedJobs[jobIndex],
            execution_date: selected_date,
        };

        unassignedJobs.splice(source.index, 1);

        typeof destinationMember['mapped_jobs'][selected_date] === 'undefined'
            ? (destinationMember['mapped_jobs'][selected_date] = [])
            : '';
        destinationMember['mapped_jobs'][selected_date].splice(destination.index, 0, job);
        members[destinationMemberIndex] = destinationMember;

        this.assignJobToMember(destinationMember['mapped_jobs'][selected_date], members[destinationMemberIndex].id);

        return {
            ...this.state,
            members: members,
            unassignedJobs: unassignedJobs,
            recreatePins: true,
        };
    };

    assignedToSameMember = (destination, source, draggableId) => {
        let members = this.state.members.slice();
        let selected_date = moment(this.state.selected_date).format('YYYY-MM-DD');

        //Source and destination are the same
        let sourceId = source.droppableId;
        let sourceMemberIndex = members.findIndex((member) => member.id === Number(sourceId));

        let jobId = Number(draggableId.substr(draggableId.indexOf('-') + 1));
        let jobIndex = members[sourceMemberIndex]['mapped_jobs'][selected_date].findIndex((job) => job.id === jobId);
        let job = {
            ...members[sourceMemberIndex]['mapped_jobs'][selected_date][jobIndex],
            execution_date: selected_date,
        };

        members[sourceMemberIndex]['mapped_jobs'][selected_date].splice(source.index, 1);

        //If member does not have any job for selected_date, create object with date as key to store the jobs
        typeof members[sourceMemberIndex]['mapped_jobs'][selected_date] === 'undefined'
            ? (members[sourceMemberIndex]['mapped_jobs'][selected_date] = [])
            : '';
        members[sourceMemberIndex]['mapped_jobs'][selected_date].splice(destination.index, 0, job);

        this.assignJobToMember(members[sourceMemberIndex]['mapped_jobs'][selected_date], members[sourceMemberIndex].id);

        return {
            ...this.state,
            members: members,
            recreatePins: true,
        };
    };

    assignedToDifferentMember = (destination, source, draggableId) => {
        let members = this.state.members.slice();
        let selected_date = moment(this.state.selected_date).format('YYYY-MM-DD');

        let sourceId = source.droppableId;
        let sourceMemberIndex = members.findIndex((member) => member.id === Number(sourceId));

        let destinationId = destination.droppableId;
        let destinationMemberIndex = members.findIndex((member) => member.id === Number(destinationId));

        let jobId = Number(draggableId.substr(draggableId.indexOf('-') + 1));
        let jobIndex = members[sourceMemberIndex]['mapped_jobs'][selected_date].findIndex((job) => job.id === jobId);
        let job = {
            ...members[sourceMemberIndex]['mapped_jobs'][selected_date][jobIndex],
            execution_date: selected_date,
        };

        members[sourceMemberIndex]['mapped_jobs'][selected_date].splice(source.index, 1);

        //If member does not have any job for selected_date, create object with date as key to store the job
        typeof members[destinationMemberIndex].mapped_jobs[selected_date] === 'undefined'
            ? (members[destinationMemberIndex]['mapped_jobs'][selected_date] = [])
            : '';
        members[destinationMemberIndex]['mapped_jobs'][selected_date].splice(destination.index, 0, job);

        this.assignJobToMember(
            members[destinationMemberIndex]['mapped_jobs'][selected_date],
            members[destinationMemberIndex].id
        );

        return {
            ...this.state,
            members: members,
            recreatePins: true,
        };
    };

    memberToUnassigned = (destination, source, draggableId) => {
        let members = this.state.members.slice();
        let onHoldJobs = this.state.onHoldJobs.slice();
        let selected_date = moment(this.state.selected_date).format('YYYY-MM-DD');

        let sourceId = Number(source.droppableId);
        let sourceMemberIndex = members.findIndex((member) => member.id === sourceId);

        let jobId = Number(draggableId.substr(draggableId.indexOf('-') + 1));
        let jobIndex = members[sourceMemberIndex]['mapped_jobs'][selected_date].findIndex((job) => job.id === jobId);
        let job = {
            ...members[sourceMemberIndex]['mapped_jobs'][selected_date][jobIndex],
            execution_date: '',
            on_hold: true,
        };

        members[sourceMemberIndex]['mapped_jobs'][selected_date].splice(source.index, 1);

        onHoldJobs.unshift(job);

        this.assignJobWithoutMember(job);

        return {
            ...this.state,
            members: members,
            onHoldJobs: onHoldJobs,
            recreatePins: true,
        };
    };

    memberToDate = (destination, source, draggableId) => {
        let members = this.state.members.slice();
        let unassignedJobs = this.state.unassignedJobs.slice();
        let selected_date = moment(this.state.selected_date).format('YYYY-MM-DD');

        let sourceId = Number(source.droppableId);
        let sourceMemberIndex = members.findIndex((member) => member.id === sourceId);

        let jobId = Number(draggableId.substr(draggableId.indexOf('-') + 1));
        let jobIndex = members[sourceMemberIndex]['mapped_jobs'][selected_date].findIndex((job) => job.id === jobId);
        let job = {
            ...members[sourceMemberIndex]['mapped_jobs'][selected_date][jobIndex],
            execution_date: selected_date,
            on_hold: false,
        };

        members[sourceMemberIndex]['mapped_jobs'][selected_date].splice(source.index, 1);

        unassignedJobs.unshift(job);

        this.assignJobWithoutMember(job);

        return {
            ...this.state,
            members: members,
            unassignedJobs: unassignedJobs,
            recreatePins: true,
        };
    };

    dateToUnassigned = (destination, source, draggableId) => {
        let unassignedJobs = this.state.unassignedJobs.slice();
        let jobId = Number(draggableId.substr(draggableId.indexOf('-') + 1));

        let onHoldJobs = [...this.state.onHoldJobs];

        let jobIndex = unassignedJobs.findIndex((job) => job.id === jobId);
        let job = {
            ...unassignedJobs[jobIndex],
            execution_date: '',
            on_hold: true,
        };

        unassignedJobs.splice(jobIndex, 1);
        onHoldJobs.push(job);

        this.assignJobWithoutMember(job);

        return {
            ...this.state,
            unassignedJobs: unassignedJobs,
            onHoldJobs: onHoldJobs,
            recreatePins: true,
        };
    };

    unassignedToDate = (destination, source, draggableId) => {
        let onHoldJobs = this.state.onHoldJobs.slice();
        let unassignedJobs = this.state.unassignedJobs.slice();
        let selected_date = moment(this.state.selected_date).format('YYYY-MM-DD');

        let jobId = Number(draggableId.substr(draggableId.indexOf('-') + 1));
        let jobIndex = onHoldJobs.findIndex((job) => job.id === jobId);
        let job = {
            ...onHoldJobs[jobIndex],
            execution_date: selected_date,
            on_hold: false,
        };

        onHoldJobs.splice(jobIndex, 1);
        unassignedJobs.push(job);

        this.assignJobWithoutMember(job);

        return {
            ...this.state,
            unassignedJobs: unassignedJobs,
            onHoldJobs: onHoldJobs,
            recreatePins: true,
        };
    };

    assignToDate = (destination, source, draggableId) => {
        let sourceId = source.droppableId;
        let jobs = this.getJobDataFromState(sourceId, draggableId);
        let jobSourceName = this.getJobSourceName(sourceId);

        let jobId = Number(draggableId.substr(draggableId.indexOf('-') + 1));
        let jobIndex = jobs.findIndex((job) => job.id === jobId);
        let job = { ...jobs[jobIndex] };

        let date = this.getExecutionDay(destination.droppableId);
        let formattedDate = moment(date).format('YYYY-MM-DD');
        job.on_hold = false;
        job.execution_date = formattedDate;

        let newState = {
            ...this.state,
            recreatePins: true,
        };

        if (jobSourceName === 'members') {
            let memberIndex = this.getMemberIndexFromSource(sourceId);
            let selectedDate = moment(this.state.selected_date).format('YYYY-MM-DD');
            newState.members[memberIndex]['mapped_jobs'][selectedDate].splice(jobIndex, 1);
            newState.unassignedJobs.push(job);
        } else if (jobSourceName === 'onHoldJobs') {
            newState.onHoldJobs.splice(jobIndex, 1);
            newState.unassignedJobs.push(job);
        } else {
            newState.unassignedJobs[jobIndex] = job;
        }

        this.assignJobWithoutMember(job);

        return newState;
    };

    getJobDataFromState = (sourceId, draggableId) => {
        if (sourceId === '0') {
            return this.state.onHoldJobs.slice();
        } else if (sourceId === '01') {
            return this.state.unassignedJobs.slice();
        } else {
            let members = this.state.members.slice();
            let selectedDate = moment(this.state.selected_date).format('YYYY-MM-DD');
            let memberIndex = this.getMemberIndexFromSource(sourceId);

            return members[memberIndex]['mapped_jobs'][selectedDate].slice();
        }
    };

    getExecutionDay = (selectedDay) => {
        //Make sure day of the week is positive number
        let day = Math.abs(selectedDay);
        let currentDay = moment().day();

        return currentDay - day >= 0 ? moment().day(day + 7) : moment().day(day);
    };

    getJobSourceName = (sourceId) => {
        //Default to members if no other check passes
        let jobSourceName = 'members';

        if (sourceId === '0') {
            jobSourceName = 'onHoldJobs';
        } else if (sourceId === '01') {
            jobSourceName = 'unassignedJobs';
        }

        return jobSourceName;
    };

    getMemberIndexFromSource = (sourceId) => {
        return this.state.members.findIndex((member) => member.id === Number(sourceId));
    };

    onDragEnd = (result) => {
        const { destination, source, draggableId } = result;

        if (!destination) {
            return;
        }

        let sourceId = source.droppableId;
        let destinationId = destination.droppableId;

        if (sourceId === '0' && destinationId === '0') {
            return;
        }

        if (sourceId === '01' && destinationId === '01') {
            return;
        }

        if (destination.droppableId === source.droppableId && destination.index === source.index) {
            return;
        }

        let newState;

        let weekDaysDestinationIds = ['-1', '-2', '-3', '-4', '-5'];
        if (weekDaysDestinationIds.includes(destinationId)) {
            newState = this.assignToDate(destination, source, draggableId);
        } else if (sourceId === '0' && destinationId === '01') {
            newState = this.unassignedToDate(destination, source, draggableId);
        } else if (sourceId === '01' && destinationId === '0') {
            newState = this.dateToUnassigned(destination, source, draggableId);
        } else if (sourceId === '0' && sourceId !== destinationId) {
            newState = this.unassignedToMember(destination, source, draggableId);
        } else if (sourceId === '01' && destinationId !== '0' && sourceId !== destinationId) {
            newState = this.dateToMember(destination, source, draggableId);
        } else if (sourceId !== '0' && sourceId !== '01' && sourceId === destinationId) {
            newState = this.assignedToSameMember(destination, source, draggableId);
        } else if (
            sourceId !== '0' &&
            destinationId !== '0' &&
            sourceId !== '01' &&
            destinationId !== '01' &&
            sourceId !== destinationId
        ) {
            newState = this.assignedToDifferentMember(destination, source, draggableId);
        } else if (destinationId === '0') {
            newState = this.memberToUnassigned(destination, source, draggableId);
        } else if (destinationId === '01') {
            newState = this.memberToDate(destination, source, draggableId);
        }

        this.setState(newState);
    };

    handleClick = (job) => {
        window.open(this.props.baseUrl + '/jobs/' + job.id, '_blank');
    };

    handleDateChange = (date) => {
        if (moment(date).isValid()) {
            this.setState({ selected_date: date });
        } else {
            this.setState({ selected_date: null });
        }
    };

    handleMultiSelectChange = (data) => {
        let selected = [];
        if (data && data.length > 0) {
            selected = [...data];
        }

        this.setState({
            selected_members: selected,
            recreatePins: true,
        });
    };

    stopPinRecreation = () => {
        this.setState({
            recreatePins: false,
        });
    };

    setModalShow = (e, show, job) => {
        e.stopPropagation();

        this.setState({
            modalShow: show,
            modalJob: job,
        });
    };

    assignJobWithoutMember(job) {
        const provider = this.props.providerId;

        axios
            .post(`/providers/${provider}/jobs/assign-without-member`, {
                job: job,
            })
            .then((res) => {
                this.setState({ loading: false });
                toastr.success('Job order successfully updated');
            })
            .catch(() => {
                this.setState({ loading: false });
                toastr.error('There was a problem, please try updating job order again');
            });
    }

    assignJobToMember(jobs, memberId) {
        const provider = this.props.providerId;

        axios
            .post(`/providers/${provider}/team/${memberId}/assign-job`, {
                jobs: jobs,
            })
            .then((res) => {
                this.setState({ loading: false });
                toastr.success('Job order successfully updated');
            })
            .catch(() => {
                this.setState({ loading: false });
                toastr.error('There was a problem, please try updating job order again');
            });
    }

    cacheFilters() {
        const provider = this.props.providerId;
        const data = {};

        data.selected_members = this.state.selected_members.map((member) => {
            return { label: member.label, value: member.value };
        });
        data.selected_date = this.state.selected_date;
        data.show_tip_offs = this.state.show_tip_offs;
        data.show_waste_containers = this.state.show_waste_containers;

        axios
            .post(`/providers/${provider}/jobs/assignment-filters`, data)
            .then((res) => {
                toastr.success('Filters saved');
            })
            .catch(() => {
                toastr.error('Failed to save filters');
            });
    }

    handleChange = (e) => {
        const name = e.target.name;

        this.setState(
            {
                [name]: !this.state[name],
            },
            () => {
                this.setState({
                    recreatePins: true,
                });
            }
        );
    };

    handleJobSelect = (jobId) => {
        this.setState((prevState) => {
            if (prevState.selectedJobs.includes(jobId)) {
                return {
                    selectedJobs: prevState.selectedJobs.filter((id) => id !== jobId),
                };
            } else {
                return {
                    selectedJobs: [...prevState.selectedJobs, jobId],
                };
            }
        });
    };

    assignMultipleJobs = (memberId) => {
        let members = [...this.state.members];
        let onHoldJobs = [...this.state.onHoldJobs];
        let unassignedJobs = [...this.state.unassignedJobs];
        let selectedJobs = [...this.state.selectedJobs];
        let selected_date = moment(this.state.selected_date).format('YYYY-MM-DD');

        let memberIndex = members.findIndex((member) => member.id === memberId);
        let member = { ...members[memberIndex] };

        if (typeof member.mapped_jobs[selected_date] === 'undefined') {
            member.mapped_jobs[selected_date] = [];
        }

        selectedJobs.forEach((jobId) => {
            let unassignedJob = unassignedJobs.find((j) => j.id === jobId);
            let onHoldJob = onHoldJobs.find((j) => j.id === jobId);

            if (onHoldJob) {
                onHoldJob = {
                    ...onHoldJob,
                    execution_date: selected_date,
                    on_hold: false,
                };

                onHoldJobs = onHoldJobs.filter((j) => j.id !== jobId);

                member['mapped_jobs'][selected_date].push(onHoldJob);
            }

            if (unassignedJob) {
                unassignedJob = {
                    ...unassignedJob,
                    execution_date: selected_date,
                };

                unassignedJobs = unassignedJobs.filter((j) => j.id !== jobId);

                member['mapped_jobs'][selected_date].push(unassignedJob);
            }
        });

        selectedJobs = [];

        members[memberIndex] = member;

        this.setState({
            members,
            onHoldJobs,
            unassignedJobs,
            selectedJobs,
            recreatePins: true,
        });

        this.assignJobToMember(member['mapped_jobs'][selected_date], member.id);
    };
    quickAssign = (jobId, memberId) => {
        let members = [...this.state.members];
        let onHoldJobs = [...this.state.onHoldJobs];
        let unassignedJobs = [...this.state.unassignedJobs];
        let selected_date = moment(this.state.selected_date).format('YYYY-MM-DD');

        let memberIndex = members.findIndex((member) => member.id === memberId);
        if (memberIndex === -1) return;
        let member = { ...members[memberIndex] };
        if (!member.mapped_jobs) member.mapped_jobs = {};
        if (!member.mapped_jobs[selected_date]) member.mapped_jobs[selected_date] = [];

        let unassignedJob = unassignedJobs.find((j) => j.id === jobId);
        let onHoldJob = onHoldJobs.find((j) => j.id === jobId);

        let assignedJob = null;
        let previousMemberIndex = null;
        for (let i = 0; i < members.length; i++) {
            const jobsOnDate = members[i].mapped_jobs?.[selected_date] || [];
            const foundJob = jobsOnDate.find((j) => j.id === jobId);
            if (foundJob) {
                assignedJob = foundJob;
                previousMemberIndex = i;
                break;
            }
        }

        if (assignedJob && previousMemberIndex !== null) {
            members[previousMemberIndex].mapped_jobs[selected_date] = members[previousMemberIndex].mapped_jobs[
                selected_date
            ].filter((j) => j.id !== jobId);
            assignedJob = { ...assignedJob, execution_date: selected_date, on_hold: false };
        }

        if (unassignedJob) {
            unassignedJobs = unassignedJobs.filter((j) => j.id !== jobId);
            unassignedJob = { ...unassignedJob, execution_date: selected_date };
        }

        if (onHoldJob) {
            onHoldJobs = onHoldJobs.filter((j) => j.id !== jobId);
            onHoldJob = { ...onHoldJob, execution_date: selected_date, on_hold: false };
        }

        member.mapped_jobs[selected_date].push(assignedJob || unassignedJob || onHoldJob);

        members[memberIndex] = member;

        this.setState({
            members,
            onHoldJobs,
            unassignedJobs,
            recreatePins: true,
        });

        this.assignJobToMember(member.mapped_jobs[selected_date], member.id);
    };
    
    unassignJob = (jobId, memberId, target) => {
        let members = [...this.state.members];
        let onHoldJobs = [...this.state.onHoldJobs];
        let unassignedJobs = [...this.state.unassignedJobs];

        let selected_date = moment(this.state.selected_date).format('YYYY-MM-DD');

        let memberIndex = members.findIndex((m) => m.id === memberId);
        if (memberIndex === -1) return;

        let jobs = members[memberIndex].mapped_jobs?.[selected_date] || [];
        let jobIndex = jobs.findIndex((j) => j.id === jobId);
        if (jobIndex === -1) return;

        let job = { ...jobs[jobIndex] };

        members[memberIndex].mapped_jobs[selected_date].splice(jobIndex, 1);

        if (target === 'onHold') {
            job.execution_date = '';
            job.on_hold = true;
            onHoldJobs.unshift(job);
        }

        if (target === 'unassigned') {
            job.execution_date = selected_date;
            job.on_hold = false;
            unassignedJobs.unshift(job);
        }

        this.setState({
            members,
            onHoldJobs,
            unassignedJobs,
            recreatePins: true,
        });

        this.assignJobWithoutMember(job);
    };
    render() {
        let selected_members = this.state.members.filter((member, index) => {
            let selectedMember = this.state.selected_members.find((selectedMember) => {
                return selectedMember.value === member.id;
            });

            return typeof selectedMember !== 'undefined';
        });

        const { activeTab } = this.state;

        return (
            <Fragment>
                <GoogleMap
                    jobs={this.props.jobs}
                    mapsApiKey={this.props.mapsApiKey}
                    baseUrl={this.props.baseUrl}
                    selectedDate={this.state.selected_date}
                    unassignedJobs={this.state.unassignedJobs}
                    members={selected_members}
                    recreatePins={this.state.recreatePins}
                    stopPinRecreation={this.stopPinRecreation}
                    tipOffs={this.props.tipOffs}
                    showTipOffs={this.state.show_tip_offs}
                    wasteContainers={this.props.wasteContainers}
                    showWasteCointainers={this.state.show_waste_containers}
                />
                <div className="row" style={{ margin: '20px 0' }}>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-8">
                                <FormMultiSelect
                                    name="team_members"
                                    options={this.props.members.map((m) => ({
                                        value: m.id,
                                        label: m.name,
                                    }))}
                                    handleMultiSelectChange={this.handleMultiSelectChange}
                                    prefixes={this.state.selected_members}
                                    label="Wascle Team Member"
                                />
                            </div>
                            <div className="col-md-4 d-flex flex-column">
                                <button className="btn btn-cw-primary mt-auto mb-0" onClick={() => this.cacheFilters()}>
                                    Save Filters
                                </button>
                            </div>
                            <div className="col-md-12">
                                <FormCheckbox
                                    name="show_tip_offs"
                                    label="Show tip offs"
                                    checked={this.state.show_tip_offs}
                                    handleChange={this.handleChange}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="col-md-12">
                            <label>Date</label>
                            <DatePicker
                                className="form-control"
                                placeholderText="Select day"
                                onChange={(date) => this.handleDateChange(date)}
                                selected={this.state.selected_date}
                                dateFormat="dd/MM/yyyy"
                                isClearable
                            />
                        </div>
                    </div>
                </div>

                <DragDropContext onDragEnd={this.onDragEnd}>
                    <div className="row">
                        {selected_members.map((member, index) => {
                            return (
                                <div className="col-xl-12 mb-4" style={{ width: '100%' }} key={member.id}>
                                    <MemberJobList
                                        jobs={member.mapped_jobs[moment(this.state.selected_date).format('YYYY-MM-DD')]}
                                        member={member}
                                        onClick={this.handleClick}
                                        color={this.state.iconColors[index]}
                                        showModal={this.setModalShow}
                                        showTipOffModal={this.setTipOffModalShow}
                                        assignMultipleJobs={this.assignMultipleJobs}
                                        members={this.state.selected_members}
                                        selectedJobs={this.state.selectedJobs}
                                        quickAssign={this.quickAssign}
                                        providerId={this.props.providerId}
                                        updateSpecialRequests={this.updateSpecialRequests}
                                        unassignJob={this.unassignJob}
                                    />
                                </div>
                            );
                        })}
                        <div className="col-xl-12">
                            <ul className="nav nav-tabs d-flex justify-content-between" style={{ width: '100%' }}>
                                <li className="nav-item w-75 text-center">
                                    <a
                                        className={`nav-link ${activeTab === 'date' ? 'active' : ''}`}
                                        onClick={() => this.setActiveTab('date')}
                                    >
                                        Jobs That Need Allocating Today
                                        <h4
                                            className="title text-center"
                                            style={{
                                                borderBottom: '2px solid #d73030',
                                            }}
                                        >
                                            {this.props.title}
                                        </h4>
                                    </a>
                                </li>
                                <li className="nav-item w-25 text-center">
                                    <a
                                        className={`nav-link ${activeTab === 'unassigned' ? 'active' : ''}`}
                                        onClick={() => this.setActiveTab('unassigned')}
                                    >
                                        On Hold Jobs
                                        <h4
                                            className="title text-center"
                                            style={{
                                                borderBottom: '2px solid #d73030',
                                            }}
                                        >
                                            {this.props.title}
                                        </h4>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        {this.state.selectedJobs.length > 0 ? (
                            <div className="col-xl-12">
                                <div className="row">
                                    <div className="col-md-8" style={{ marginTop: '25px' }}>
                                        <button
                                            className="btn btn-cw-primary mt-auto mb-0"
                                            onClick={(e) =>
                                                this.showUpdateExecutionDateModal(e, true, this.props.selectedJobs)
                                            }
                                        >
                                            Change Planned Date
                                        </button>
                                        <button
                                            className="btn btn-cw-primary mt-auto mb-0"
                                            onClick={(e) =>
                                                this.showReassignToSubContractorModal(e, true, this.props.selectedJobs)
                                            }
                                            style={{ marginLeft: '25px' }}
                                        >
                                            Re-assign Job(s)
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            ''
                        )}
                        <div className="col-xl-12" style={{ width: '100%' }}>
                            {activeTab === 'unassigned' && (
                                <UnassignedJobsList
                                    id={0}
                                    jobs={this.state.onHoldJobs}
                                    onClick={this.handleClick}
                                    selectedDate={this.state.selected_date}
                                    showModal={this.setModalShow}
                                    selectedJobs={this.state.selectedJobs}
                                    onJobSelect={this.handleJobSelect}
                                    members={this.state.selected_members}
                                    quickAssign={this.quickAssign}
                                    updateSpecialRequests={this.updateSpecialRequests}
                                />
                            )}
                            {activeTab === 'date' && (
                                <DateJobsList
                                    id="01"
                                    jobs={this.state.unassignedJobs}
                                    onClick={this.handleClick}
                                    selectedDate={this.state.selected_date}
                                    showModal={this.setModalShow}
                                    selectedJobs={this.state.selectedJobs}
                                    onJobSelect={this.handleJobSelect}
                                    members={this.state.selected_members}
                                    quickAssign={this.quickAssign}
                                    updateSpecialRequests={this.updateSpecialRequests}
                                />
                            )}
                        </div>
                    </div>
                </DragDropContext>

                {this.state.showJob.job ? <DisplayJob job={this.state.showJob.job} /> : ''}

                {this.state.modalShow && (
                    <AdminNotesModal show={this.state.modalShow} onHide={this.setModalShow} job={this.state.modalJob} />
                )}
                {this.state.showUpdateExecutionDateModal && (
                    <UpdateExecutionDateModal
                        show={this.state.modalShow}
                        onHide={this.showUpdateExecutionDateModal}
                        selectedJobs={this.state.selectedJobs}
                    />
                )}
                {this.state.tipOffModalShow && this.state.tipOffOperative && (
                    <TipOffModal
    show={this.state.tipOffModalShow}
    providerId={this.props.providerId}
    operative={this.state.tipOffOperative} 
    onHide={() => this.setTipOffModalShow(false, null)}
    onClose={(result) => {
        if (result?.success) {
            this.setState((prev) => ({
                members: prev.members.map((m) =>
                    m.id === result.operativeId
                        ? { ...m, needsTipOff: true, tipOff: result.tipOff }
                        : m
                ),
            }));
        }

        this.setTipOffModalShow(false, null);
    }}
/>

                )}

                {this.state.showReassignToSubContractorModal && (
                    <ReassignToSubContractorModal
                        show={this.state.modalShow}
                        onHide={this.showReassignToSubContractorModal}
                        selectedJobs={this.state.selectedJobs}
                        serviceProviders={this.props.serviceProviders}
                    />
                )}
            </Fragment>
        );
    }
}

export default MembersJobsList;

if (document.getElementById('member-order-jobs')) {
    let element = document.getElementById('member-order-jobs');
    console.log(element.dataset.assigned_operatives);
    ReactDOM.render(
        <MembersJobsList
            providerId={JSON.parse(element.dataset.provider_id)}
            jobs={JSON.parse(element.dataset.jobs)}
            members={JSON.parse(element.dataset.members)}
            serviceProviders={JSON.parse(element.dataset.providers)}
            unassignedJobs={JSON.parse(element.dataset.unassigned_jobs)}
            selectedMembers={JSON.parse(element.dataset.selected_members)}
            mapsApiKey={element.dataset.maps_key}
            baseUrl={element.dataset.base_url}
            onHoldJobs={JSON.parse(element.dataset.on_hold_jobs)}
            selectedDate={element.dataset.selected_date}
            tipOffs={JSON.parse(element.dataset.tip_offs)}
            showTipoffs={element.dataset.show_tip_offs}
            wasteContainers={JSON.parse(element.dataset.waste_containers)}
            showWasteContainers={element.dataset.show_waste_containers}
            assignedOperatives={JSON.parse(element.dataset.assigned_operatives || '[]')}
        />,
        element
    );
}
